module.exports = {
  "login": {
    "telLogin": "Mobile login",
    "accountLogin": "Account login",
    "accountHint": "Please enter your account number.",
    "passwordHint": "Password",
    "passwordToastHint": "Please input a password",
    "login": "Login",
    "forgetPassword": "Forget Password?",
    "telHint": "Please enter your cell phone number.",
    "code": "Verification Code",
    "codeHint": "Please enter the verification code.",
    "telCode": "Mobile phone verification code",
    "telCodeHint": "Please enter the mobile phone verification code",
    "sendCode": "Send Code"
  },
};


// WEBPACK FOOTER //
// ./src/i18n/login/en.js